export const MARK_SRC = "/brand/aicendor-mark.png";
export const LOGO_SRC = "/brand/aicendor-logo.png";

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img src={MARK_SRC} alt="" aria-hidden="true" className={`${className} object-contain`} draggable={false} />
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-10 w-10 drop-shadow-[0_0_8px_rgba(212,175,55,0.3)]" />
    <span className="font-sans text-lg font-medium tracking-[0.28em] text-white">
      <span className="gold-text">AI</span>CENDOR
    </span>
  </span>
);
